import React from "react";
import { Tag, Spin, Icon } from "antd";

type Props = {
    title: string;
    isInProgress: boolean;
    description: string;
}

export default function CardTitleWithProgressIndicator({ title, isInProgress, description }: Props) {
    return (
        <>
            {isInProgress ? (
                <div className="ant-card-meta-detail">
                    <div className="ant-card-meta-title" style={{ fontSize: "16px", fontWeight: "500" }}>{title}</div>
                    <Tag color="orange">
                        {description} <Spin indicator={<Icon type="loading-3-quarters" spin style={{ fontSize: "12px", marginLeft: "6px" }} />} />
                    </Tag>
                </div>
            ) : title}
        </>
    )
}